"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsAllZero = void 0;
const getIsAllZero = (value) => value &&
    value
        ?.replace(/[\s-]/g, '')
        .split('')
        .every((v) => v === '0');
exports.getIsAllZero = getIsAllZero;
